import { PreloadedState } from "redux";
import { createBrowserHistory } from "history";
import createRootReducer from "./reducer";
import { configureStore } from "@reduxjs/toolkit";

export const history = createBrowserHistory();

export const store = configureStore({
  reducer: createRootReducer(),
});

export function setupStore(preloadedState?: PreloadedState<RootState>) {
  return configureStore({
    reducer: createRootReducer(),
    preloadedState,
  });
}

export type AppDispatch = typeof store.dispatch;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppStore = ReturnType<typeof setupStore>;
